/* eslint-disable no-undef */

'use strict';

window.Affirm = {};

Affirm.updateAffirmPrice = function(newAffirmPrice) {
  const el = document.querySelector('.affirm-as-low-as');
  if (el === null) {
    return;
  }
  el.setAttribute('data-amount', newAffirmPrice);
  affirm.ui.refresh();
};

Affirm.displayBannerInCalendar = function() {
  const el = document.querySelector('.affirm-section');
  return el ? (el.style.display = 'block') : undefined;
};

Affirm.removeBanner = function() {
  const el = document.querySelector('.affirm-section');
  return el ? el.remove() : undefined;
};

module.exports = Affirm;



// WEBPACK FOOTER //
// ./modules/affirm_info/frontend/affirm.js